<template>
  <v-menu offset-y>
    <template #activator="{ on }">
      <v-btn
        icon
        text
        v-on="on"
      >
        <v-icon>mdi-translate</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item @click="setLocale('zh-TW')">
        <v-list-item-title>{{ $t('common.LANG_ZH_TW') }}</v-list-item-title>
        <v-icon
          v-if="$i18n.locale === 'zh-TW'"
          class="ml-2"
        >
          mdi-check
        </v-icon>
      </v-list-item>
      <v-list-item @click="setLocale('zh-CN')">
        <v-list-item-title>{{ $t('common.LANG_ZH_CN') }}</v-list-item-title>
        <v-icon
          v-if="$i18n.locale === 'zh-CN'"
          class="ml-2"
        >
          mdi-check
        </v-icon>
      </v-list-item>
      <v-list-item @click="setLocale('en')">
        <v-list-item-title>{{ $t('common.LANG_EN') }}</v-list-item-title>
        <v-icon
          v-if="$i18n.locale === 'en'"
          class="ml-2"
        >
          mdi-check
        </v-icon>
      </v-list-item>
      <v-list-item @click="setLocale('ja')">
        <v-list-item-title>{{ $t('common.LANG_JA') }}</v-list-item-title>
        <v-icon
          v-if="$i18n.locale === 'ja'"
          class="ml-2"
        >
          mdi-check
        </v-icon>
      </v-list-item>
      <v-list-item @click="setLocale('ko')">
        <v-list-item-title>{{ $t('common.LANG_KO') }}</v-list-item-title>
        <v-icon
          v-if="$i18n.locale === 'ko'"
          class="ml-2"
        >
          mdi-check
        </v-icon>
      </v-list-item>
      <v-list-item @click="setLocale('th')">
        <v-list-item-title>{{ $t('common.LANG_TH') }}</v-list-item-title>
        <v-icon
          v-if="$i18n.locale === 'th'"
          class="ml-2"
        >
          mdi-check
        </v-icon>
      </v-list-item>
      <v-list-item @click="setLocale('vi')">
        <v-list-item-title>{{ $t('common.LANG_VI') }}</v-list-item-title>
        <v-icon
          v-if="$i18n.locale === 'vi'"
          class="ml-2"
        >
          mdi-check
        </v-icon>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { setLocale } from '@/i18n';

const LOCALE_TO_VUETIFY = {
  'zh-TW': 'zhHant',
  'zh-CN': 'zhHans',
  en: 'en',
  ja: 'ja',
  ko: 'ko',
  th: 'th',
  vi: 'vi'
};

export default {
  name: 'LanguageSwitcher',
  methods: {
    async setLocale(locale) {
      await setLocale(locale);
      this.$root.$vuetify.lang.current = LOCALE_TO_VUETIFY[locale] || 'zhHant';
    }
  }
};
</script>
